import Rooms from "./rooms";

export default Rooms;

